import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import template from './index.jade';
import css from './index.styl?inline';

export class BookmarkButton extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      saved: `boolean`,
      'save-failed': `boolean`,
      'show-upsell': `boolean`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,

      helpers: {
        showUpsell: () => this.dispatchEvent(new CustomEvent(`showUpsell`)),
        closeUpsell: () => this.dispatchEvent(new CustomEvent(`closeUpsell`)),
      },
    };
  }
}

export const BookmarkButtonEl = defineAndMakeJsxFactory(`mp-bookmark-button`, BookmarkButton);
